export default __webpack_public_path__ + "static/media/tag.502ca9e5.svg";